interface LogoProps {
  spinning?: boolean
  className?: string
}

export default function Logo({ spinning = false, className = '' }: LogoProps) {
  return (
    <div className={`h-8 w-[120px] flex items-center ${className}`}>
      <img
        src="/Clip path group.svg"
        alt="Club 4X4"
        className={`h-full w-auto object-contain ${spinning ? 'animate-spin' : ''}`}
      />
    </div>
  )
}

